import React from 'react';
import { connect } from 'react-redux';
import { LICENSE_SELECTOR_SOFTWARES, possible_starter_selections, softwareStepsConfig, stepsConfig } from '../../constants';
import StartConfigurationScreen from './start_configuration_screen';
import HeadDeviceSelectorScreen from './head_device_selector_screen';
import ConfigurationEditorScreen from './configuration_editor_screen';
import PowerSupplyScreen from './power_supply_screen';
import AccessorizeScreen from './accessorize_screen';
import SaveScreen from './save_screen';
import SoftwareSelectionScreen from './software_selection_screen';
import LicenceSelectorSaveScreen from './licence_selector_save_screen';
import LicenceSelectorScreen from './licence_selector_screen';
import LicenceSelectorScreenV2 from './licence_selector_screen_v2';
import ServicePlanScreen from './service_plan_screen';

class ScreenStepper extends React.Component {
  retrieveStepFromMapping = (stepsMapping, stepId) => {
    let component = <></>;
    const mapped = stepsMapping[stepId];
    if (mapped) {
      component = mapped();
    }
    return component;
  }

  renderSoftwareLicenseConfiguration = () => {
    const stepsMapping = {
      [stepsConfig.start_screen]: () => <StartConfigurationScreen></StartConfigurationScreen>,
      [softwareStepsConfig.software_selection]: () => <SoftwareSelectionScreen></SoftwareSelectionScreen>,
      [softwareStepsConfig.licence_selector]: () => {
        if (this.props.configuration.softwareSelection === LICENSE_SELECTOR_SOFTWARES.CONTROL_EXPERT) {
          return (<LicenceSelectorScreen></LicenceSelectorScreen>);
        }
        return (<LicenceSelectorScreenV2></LicenceSelectorScreenV2>);
      } ,
      [softwareStepsConfig.service_plan]: () => <ServicePlanScreen></ServicePlanScreen>,

      [stepsConfig.save_screen]: () => <LicenceSelectorSaveScreen></LicenceSelectorSaveScreen>
    };
    return this.retrieveStepFromMapping(stepsMapping, this.props.configuration.step);
  }

  renderConfiguration = () => {
    const stepsMapping = {
      [stepsConfig.start_screen]: () => <StartConfigurationScreen></StartConfigurationScreen>,
      [stepsConfig.head_device_selector_screen]: () => <HeadDeviceSelectorScreen></HeadDeviceSelectorScreen>,
      [stepsConfig.configuration_editor_screen]: () => <ConfigurationEditorScreen></ConfigurationEditorScreen>,
      [stepsConfig.power_supply]: () => <PowerSupplyScreen></PowerSupplyScreen>,
      [stepsConfig.accessorize]: () => <AccessorizeScreen></AccessorizeScreen>,
      [stepsConfig.save_screen]: () => <SaveScreen></SaveScreen>,
    };
    return this.retrieveStepFromMapping(stepsMapping, this.props.configuration.step);
  }

  render = () => {
    let stepComponent;
    if (possible_starter_selections.SOFTWARE_LICENCE === this.props.configuration.configurationType) {
      stepComponent = this.renderSoftwareLicenseConfiguration();
    } else {
      stepComponent = this.renderConfiguration();
    }
    return (
      <React.Fragment>
        {stepComponent}
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  return state;
}

const mapDispatchToProps = dispatch => {
  return {

  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ScreenStepper);
